
import './App.css';
import Header from './componants/Header';
import Full from './componants/Full';
import Scroll from './componants/Scroll';
/* Developed by Arul */
function App() {
  /* Developed by Arul */
  return (
    <div className="App">
     <Header/>
     <Scroll/>
   <Full/>
    </div>
  );
}

export default App;
